import { filter, opacity } from "./functions";

export default function ImageLayer ({layer}) {

  return <>
    <img
      key={layer.id}
      src={layer.file?.url}
      draggable="false"
      className="prevent-long-press"
      style={{
        height:   layer.height,
        width:    layer.width,
        position: 'absolute',
        filter:   filter(layer),
        opacity:  opacity(layer),
      }}
    />
  </>
}
